import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ObjectifModel, ActionModel, UserModel } from '../../main/Models';
import { ApiService } from '../../custom-material/Services/';

@Component({
  selector: 'rm-action',
  templateUrl: './t_action.component.html',
  styleUrls: ['./action.component.less']
})
export class ActionComponent implements OnInit {

  @Input('action') action:ActionModel;
  @Input('objectifId') objectifId:number;
  @Input('singleView') singleView:boolean;
  @Input('connectedUserList') connectedUserList:string[] = [];

  @Output() closeTriggered: EventEmitter<ActionModel> = new EventEmitter();
  @Output() addTriggered: EventEmitter<ActionModel> = new EventEmitter();
  @Output() changeStatusTriggered:EventEmitter<any> = new EventEmitter();
  //@Output() usersLoadedTriggered:EventEmitter<ActionModel> = new EventEmitter();
  @Output() deleteTriggered: EventEmitter<ActionModel> = new EventEmitter();

  @Input('fold') fold:boolean = false;
  /*get showFolder()
  {
    if(this.singleView) return false;
    if(this.action.creationMode) return false;

    let contentElement:HTMLElement = this.elementRef.nativeElement.getElementsByClassName('content')[0];
    if(!contentElement) return false;
    let detailHeight = contentElement.clientHeight;
    return detailHeight > 240;
  }*/

  constructor(private elementRef:ElementRef,
              private apiService:ApiService) { }

  ngOnInit() {
    /*if(this.action!=undefined && this.action.jsonDetails!=undefined) {
      if(this.action.jsonDetails.todo!=undefined) this.showTODO = true;
      if(this.action.jsonDetails.comments!=undefined) this.showComments = true;
    }*/
    if(!this.singleView) this.loadUsers();

    setInterval(()=>{ if(this.action.saveIt) this.save(); }, 3e5);
  }

  ngOnDestroy()
  {
    if(this.action.saveIt && !this.action.creationMode) this.save();
    //TODO : clearInterval
  }

  close(save:boolean = true)
  {
    if(save) this.save();
  	this.closeTriggered.emit(this.action);
  }
  cancel()
  {
    this.action.status = -2;
    this.closeTriggered.emit(this.action);
  }

  changeStatus(newStatus:number)
  {
    this.action.actionStatus = newStatus;
    this.changeStatusTriggered.emit();
  }


  changeActionName($event)
  {
    if($event==null
    && this.action.status==-1) this.close(false);

    this.action.actionName=$event;
    if(this.action.status==-1) this.saveNewAction();
  }

  saveNewAction()
  {
    if(!this.action.actionName || this.action.actionName==='') {
      this.closeTriggered.emit(this.action);
      return;
    }

    this.action.status = 0;
    this.action.creationMode = false;

    let saveAction:any = this.action.export();
    saveAction.objectif = this.objectifId;
    this.apiService.SaveToServer('action', saveAction)
      .then((s)=>{s.subscribe((response:any)=>{
        this.action.exchange(response);
        this.action.saveIt = false;
        this.addTriggered.emit(this.action);
      });});
  }

  save()
  {
    this.apiService.UpdateToServer('action', this.action.export())
      .then((s)=>{s.subscribe((response:any)=>{
        this.action.saveIt = false;
        this.action.creationMode = false;
        this.action.origUsers = this.action.currentUsers;
      });})
  } 
 


  //showTODO:boolean = false;
  switchTODO()
  {
    if(!this.action.jsonDetails.todo) 
      this.action.jsonDetails.todo = [];
    //this.showTODO = !this.showTODO;
    this.fold = false;
  }

  //showComments:boolean = false;
  switchComments()
  {
    if(!this.action.jsonDetails.comments)
      this.action.jsonDetails.comments = [];
    //this.showComments = !this.showComments;
    this.fold = false;
  }


  //Actors
  loadUsers()
  {
    let params = this.apiService.createParams({actions: this.action.id});
    this.apiService.getFromServer('user', params)
      .then(s=>s.subscribe((response:any)=>{
        this.action.origUsers = [];
        this.action.currentUsers = [];
        for( let i in response._embedded.user) {
          let user = new UserModel(response._embedded.user[i]);
          this.action.origUsers.push(user);
          this.action.currentUsers.push(user);
        }
        //this.usersLoadedTriggered.emit(this.action);
      }));
  }

}
